/**
 * Detecção do modo "domínio próprio" no boot.
 * O nginx injeta `<meta name="bf-host-kind" content="platform|store">` no HTML (CSP de produção proíbe script inline).
 * Sem a meta (dev/vite): `*.localhost` é candidato a loja e precisa de sonda em `GET /api/public/stores/_host`.
 */
export type HostKind = 'platform' | 'store' | 'probe';

export function detectHostKind(doc: Pick<Document, 'querySelector'> = document, hostname: string = window.location.hostname): HostKind {
  const meta = doc.querySelector('meta[name="bf-host-kind"]')?.getAttribute('content');
  if (meta === 'store') return 'store';
  if (meta === 'platform') return 'platform';
  const h = hostname.toLowerCase();
  if (h !== 'localhost' && h.endsWith('.localhost')) return 'probe';
  return 'platform';
}

/** Resolve o slug da loja do domínio atual; `null` quando não há loja (404, despublicada) ou a rede falha. */
export async function probeHostStore(fetcher: typeof fetch = fetch): Promise<string | null> {
  try {
    const res = await fetcher('/api/public/stores/_host', { headers: { Accept: 'application/json' }, credentials: 'omit' });
    if (!res.ok) return null;
    const body = (await res.json()) as { slug?: unknown };
    return typeof body.slug === 'string' && body.slug ? body.slug : null;
  } catch {
    return null;
  }
}
